import { ChangeDetectionStrategy, Component, input, Input, OnInit } from '@angular/core';
import {Fattener} from '../../types/fattener.model';

import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'lib-fattener-info',
    templateUrl: './fattener-info.component.html',
    styleUrls: ['./fattener-info.component.css'],
    imports: [
    TranslatePipe
  ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FattenerInfoComponent {

  fattener = input<Fattener>();

  constructor() {}
}
